import { render, staticRenderFns } from "./GlassesLensEdit.vue?vue&type=template&id=1364bfac&"
import script from "./GlassesLensEdit.vue?vue&type=script&lang=js&"
export * from "./GlassesLensEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports